import { Trash2 } from "lucide-react";
import { Empty } from "./AdminStats";

const STATUS_OPTIONS = ["pendiente", "contactado", "aceptado", "archivado"];

const formatDate = (iso) => new Date(iso).toLocaleString("es-CO");

const VolunteerCard = ({ vol, onStatusChange, onDelete }) => (
    <div className="rounded-2xl bg-white border border-black/5 p-6" data-testid={`admin-volunteer-${vol.id}`}>
        <div className="flex flex-wrap items-start justify-between gap-3">
            <div className="min-w-0">
                <h3 className="font-display font-semibold text-brand-navy text-lg">
                    {vol.nombres} {vol.apellidos}{" "}
                    <span className="text-sm font-normal text-muted-foreground">· {vol.edad} años</span>
                </h3>
                <div className="text-sm text-muted-foreground mt-1 break-all">
                    {vol.email} · {vol.telefono} · {vol.ciudad}
                </div>
                <div className="text-xs text-muted-foreground mt-1">
                    {formatDate(vol.created_at)}
                    {vol.profesion && ` · ${vol.profesion}`}
                </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
                <select
                    value={vol.estado}
                    onChange={(e) => onStatusChange(vol.id, e.target.value)}
                    className="h-9 rounded-full bg-brand-green-light text-brand-navy px-4 text-xs font-semibold border-0 focus:outline-none focus:ring-2 focus:ring-brand-green"
                    data-testid={`admin-volunteer-status-${vol.id}`}
                >
                    {STATUS_OPTIONS.map((s) => (
                        <option key={s} value={s}>{s}</option>
                    ))}
                </select>
                <button
                    type="button"
                    onClick={() => onDelete(vol.id)}
                    className="h-9 w-9 rounded-full bg-red-50 text-red-600 hover:bg-red-600 hover:text-white transition-colors flex items-center justify-center"
                    title="Eliminar"
                    data-testid={`admin-delete-vol-${vol.id}`}
                >
                    <Trash2 size={16} />
                </button>
            </div>
        </div>
        <div className="mt-4 pt-4 border-t border-black/5 grid sm:grid-cols-2 gap-4">
            <div>
                <div className="text-xs uppercase tracking-wider font-bold text-brand-green">Áreas de interés</div>
                <div className="mt-2 flex flex-wrap gap-2">
                    {vol.areas_interes.map((a) => (
                        <span key={a} className="text-xs px-2 py-1 rounded-full bg-brand-cream text-brand-navy">{a}</span>
                    ))}
                </div>
            </div>
            <div>
                <div className="text-xs uppercase tracking-wider font-bold text-brand-green">Disponibilidad</div>
                <div className="mt-2 text-sm text-muted-foreground">{vol.disponibilidad}</div>
            </div>
        </div>
        {vol.experiencia && (
            <div className="mt-4">
                <div className="text-xs uppercase tracking-wider font-bold text-brand-green">Experiencia</div>
                <div className="text-sm text-muted-foreground mt-1 whitespace-pre-wrap">{vol.experiencia}</div>
            </div>
        )}
        <div className="mt-4">
            <div className="text-xs uppercase tracking-wider font-bold text-brand-green">Motivación</div>
            <div className="text-sm text-muted-foreground mt-1 whitespace-pre-wrap leading-relaxed">{vol.motivacion}</div>
        </div>
    </div>
);

export const VolunteersTab = ({ volunteers, onStatusChange, onDelete }) => (
    <div className="space-y-3" data-testid="admin-volunteers-list">
        {volunteers.length === 0 && <Empty text="No hay voluntarios aún." />}
        {volunteers.map((v) => (
            <VolunteerCard key={v.id} vol={v} onStatusChange={onStatusChange} onDelete={onDelete} />
        ))}
    </div>
);
